export default __webpack_public_path__ + "static/media/Group57.5c386b97.svg";